var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group-page" }, [
    _vm.accessError && _vm.initialised
      ? _c("div", { staticClass: "alert alert-danger access-error-message" }, [
          _vm._v(
            "\n        Group not found or you do not have access to it.\n    "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.initialised && !_vm.accessError
      ? _c(
          "div",
          { staticClass: "group-page__menu-container" },
          [
            !_vm.mobileView
              ? _c("group-page-menu-top-section", {
                  attrs: {
                    group: _vm.group,
                    "show-buttons-panel": _vm.viewer_state.is_member,
                    "show-name": !_vm.viewer_state.is_member,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.viewer_state.is_member && !_vm.mobileView
              ? _c("group-page-menu-actions", {
                  on: {
                    openSettings: _vm.openSettings,
                    startChat: _vm.startChat,
                    leaveGroup: _vm.leaveGroup,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.viewer_state.is_member && !_vm.mobileView
              ? _c("group-page-menu-sharing-panel", {
                  attrs: {
                    group: _vm.group,
                    "sharing-state": _vm.sharing_state,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.viewer_state.is_member && !_vm.mobileView
              ? _c("group-page-menu-members", { attrs: { group: _vm.group } })
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileView
              ? _c("group-page-menu-mobile", {
                  attrs: {
                    group: _vm.group,
                    "sharing-state": _vm.sharing_state,
                  },
                  on: {
                    openSettings: _vm.openSettings,
                    startChat: _vm.startChat,
                    leaveGroup: _vm.leaveGroup,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.initialised && !_vm.accessError
      ? _c(
          "div",
          { staticClass: "group-page__content-container" },
          [
            _vm.initialised && !_vm.viewer_state.is_member
              ? _c("group-page-public-story")
              : _vm._e(),
            _vm._v(" "),
            _vm.initialised && _vm.viewer_state.is_member
              ? _c("router-view")
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }